import React, { useState, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { withCookies } from 'react-cookie';
import '../../css/huerto/scoringTable.css';
import '../../css/huerto/scoring.css';
import {
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    TablePagination,
} from '@mui/material';
import Input from '../../bronson/Input';
import OpComercialFilter from '../scoring/componentScoringTable/OpComercialFilter';
import FunctionGeneral from '../scoring/functionsGeneral';

function colorPrintExcel(color) {
    switch (color) {
        case 'A':
            return 'Verde';

        case 'B':
            return 'Amarillo';

        case 'C':
            return 'Rojo';
        default:
            return '';
    }
}
function updateData(metricaActividad) {
    var data = [];
    metricaActividad.forEach(element => {
        var dataParse = JSON.parse(element.QUCSUBAGRUPACION);
        let jsonToAdd = {
            AÑO: element.AÑO,
            BrandCode: element.BrandCode,
            BrandDescription: element.BrandDescription,
            CODECONSE: element.CODECONSE,
            CodOperation: element.CodOperation,
            DIA: element.DIA,
            Descriptionlog: element.Descriptionlog,
            MES: element.MES,
            NOMBRECONCE: element.NOMBRECONCE.trim(),
            ProdBox:
                dataParse !== null
                    ? dataParse.ProdBoxId == '132 '
                        ? 'RENTING'
                        : dataParse.ProdBoxId == '158 '
                        ? 'NEXT'
                        : dataParse.ProdBoxId == '134 '
                        ? 'CPC'
                        : ' '
                    : ' ',
            Customer_Vehicle:
                dataParse != null
                    ? colorPrintExcel(dataParse.CustomerVehicle[0]) +
                      '/' +
                      colorPrintExcel(dataParse.CustomerVehicle[1])
                    : '',
            USRALTA: element.USRALTA,
            VENDEDOR: element.VENDEDOR,
            idConceptolog: element.idConceptolog,
        };
        data.push(jsonToAdd);
    });
    return data;
}

function desglozarString(data, caso) {
    var data = JSON.parse(data);
    switch (caso) {
        case 0:
            try {
                return new FunctionGeneral().Producto(data.ProdBoxId);
            } catch {
                return <div></div>;
            }

        case 1:
            try {
                return (
                    <div style={{ display: 'flex' }}>
                        <span style={{ marginLeft: '5px' }}>
                            {new FunctionGeneral().EsferaColor(
                                data.CustomerVehicle[0],
                                ''
                            )}
                        </span>
                        <span style={{ marginLeft: '10px' }}>
                            {new FunctionGeneral().EsferaColor(
                                data.CustomerVehicle[1],
                                'iconLeft-tableVencimiento'
                            )}
                        </span>
                    </div>
                );
            } catch {
                return <div></div>;
            }

        default:
            return <div></div>;
    }
}
function optActividad(data) {
    var rowOpt = [];
    rowOpt.push(
        <option value={''} key={'_0'}>
            Todas
        </option>
    );
    data.forEach(element => {
        rowOpt.push(
            <option
                value={element.TPNIDCONCEPTOLOG}
                key={element.TPNIDCONCEPTOLOG}
            >
                {element.TPCDESCRIPCION}
            </option>
        );
    });
    return rowOpt;
}

const ActividadUsr = props => {
    const [rowsPerPage, setrowsPerPage] = useState(10);
    const [page, setPage] = useState(0);
    const [metricaActividad, setmetricaActividad] = useState(
        props.metricaActividad
    );
    const [filter, setFilter] = useState([]);
    const [optMarca, setOptMarca] = useState([]);
    const [productoComercial, setProductoComercial] = useState([]);

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = event => {
        setrowsPerPage(+event.target.value);
        setPage(0);
    };

    useEffect(() => {
        if (optMarca.length === 0) {
            var año_Mayor = 0;
            var año_Menor = 99999;
            var optSelectMarca = [];
            if (metricaActividad.length > 0) {
                let optMarca = [];

                metricaActividad.forEach(element => {
                    optMarca.push([
                        element.BrandDescription,
                        element.BrandCode,
                    ]);
                    if (element.AÑO > año_Mayor) año_Mayor = element.AÑO;
                    if (element.AÑO < año_Menor) año_Menor = element.AÑO;
                });
                optMarca = new FunctionGeneral().reemplazarDuplicados(optMarca);
                optSelectMarca.push(
                    <option value="" key={'null'}>
                        Todas
                    </option>
                );
                optMarca.forEach(element => {
                    optSelectMarca.push(
                        <option value={element[1]} key={element[1]}>
                            {element[0]}
                        </option>
                    );
                });
            }
            document.getElementById('fechDesdeAño').value = año_Menor;
            document.getElementById('fechHastaAño').value = año_Mayor;
            document.getElementById('fechDesdeMes').value = 1;
            document.getElementById('fechHastaMes').value = 12;
            setOptMarca(optSelectMarca);
        }
    }, []);

    useEffect(() => {
        var actualState = props.metricaActividad;
        filter.forEach(filt => {
            var newState = [];
            var filterstr = filt[1];
            if (filt[0] === 'Opefinanciera') {
                actualState.forEach(element => {
                    if (
                        filterstr.toUpperCase() ===
                        element.CodOperation.substring(
                            0,
                            filterstr.length
                        ).toUpperCase()
                    )
                        newState.push(element);
                });
            } else if (filt[0] === 'Usuario') {
                actualState.forEach(element => {
                    if (
                        filterstr.toUpperCase() ===
                        element.USRALTA.substring(
                            0,
                            filterstr.length
                        ).toUpperCase()
                    )
                        newState.push(element);
                });
            } else if (filt[0] === 'Vendedor') {
                actualState.forEach(element => {
                    if (
                        filterstr.toUpperCase() ===
                        element.VENDEDOR.substring(
                            0,
                            filterstr.length
                        ).toUpperCase()
                    )
                        newState.push(element);
                });
            } else if (filt[0] === 'MarcaSelected') {
                if (filterstr !== '')
                    actualState.forEach(element => {
                        if (filterstr === element.BrandCode)
                            newState.push(element);
                    });
                else newState = actualState;
            } else if (
                filt[0] === 'fechHastaAño' ||
                filt[0] === 'fechHastaMes'
            ) {
                var mes = document.getElementById('fechHastaMes').value;
                var año = document.getElementById('fechHastaAño').value;
                if (año !== '')
                    actualState.forEach(element => {
                        if (año > element.AÑO) newState.push(element);
                        else if (año === element.AÑO && mes >= element.MES)
                            newState.push(element);
                    });
            } else if (
                filt[0] === 'fechDesdeAño' ||
                filt[0] === 'fechDesdeMes'
            ) {
                var mes = document.getElementById('fechDesdeMes').value;
                var año = document.getElementById('fechDesdeAño').value;
                if (año !== '')
                    actualState.forEach(element => {
                        if (año < element.AÑO) newState.push(element);
                        else if (año === element.AÑO && mes <= element.MES)
                            newState.push(element);
                    });
            } else if (filt[0] === 'OperacionActividad') {
                if (filterstr !== '')
                    actualState.forEach(element => {
                        if (
                            filterstr.toString() ===
                            element.idConceptolog.toString()
                        )
                            newState.push(element);
                    });
                else newState = actualState;
            } else if (filt[0] === 'OperacionSelected') {
                if (filterstr !== '' && filterstr !== 'null')
                    actualState.forEach(element => {
                        var data = JSON.parse(element.QUCSUBAGRUPACION);
                        try {
                            if (data.ProdBoxId)
                                if (
                                    filterstr.toString() ===
                                    data.ProdBoxId.toString()
                                )
                                    newState.push(element);
                        } catch {}
                    });
                else newState = actualState;
            }

            actualState = newState;
        });
        setmetricaActividad(actualState);
    }, [filter]);

    const onChangeFilter = target => {
        var _filter = [];
        var update = false;
        filter.forEach(element => {
            if (element[0] === target.target.id) {
                update = true;
                _filter.push([target.target.id, target.target.value]);
            } else _filter.push(element);
        });
        if (!update) _filter.push([target.target.id, target.target.value]);

        setFilter(_filter);
    };

    var rows = [];
    metricaActividad
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
        .map(row =>
            rows.push(
                <TableRow
                    id={row.CodOperation + rows.length}
                    key={row.CodOperation + rows.length}
                    style={{
                        height: '48px',
                        marginTop: '5px',
                        marginBottom: '5px',
                    }}
                    className="iconHover"
                >
                    <TableCell>{row.AÑO}</TableCell>
                    <TableCell>{row.MES}</TableCell>
                    <TableCell>{row.DIA}</TableCell>
                    <TableCell>{row.CodOperation}</TableCell>
                    <TableCell>{row.BrandDescription}</TableCell>
                    <TableCell>{row.Descriptionlog.split('-')[1]}</TableCell>
                    <TableCell>{row.NOMBRECONCE.trim()}</TableCell>
                    <TableCell>{row.CODECONSE}</TableCell>
                    <TableCell>{row.VENDEDOR}</TableCell>
                    <TableCell>{row.USRALTA}</TableCell>
                    <TableCell>
                        {desglozarString(row.QUCSUBAGRUPACION, 0)}
                    </TableCell>
                    <TableCell style={{ paddingLeft: '7`x' }}>
                        {desglozarString(row.QUCSUBAGRUPACION, 1)}
                    </TableCell>
                </TableRow>
            )
        );

    return (
        <React.Fragment>
            <div className="u-pb-small u-rema-full-height">
                <section className="o-content-section o-page-wrap o-page-wrap--xsmall">
                    <div className="o-component-wrapper u-hide@s">
                        <span
                            className="back-to-matrix u-float-left"
                            onClick={() => props.setviewActividadUsr(false)}
                        >
                            <i className="c-icon c-icon--[semantic-back] c-icon--small" />
                            <label className="iconHover">
                                Volver a metricas
                            </label>
                        </span>
                        <h3 className="u-text-center">
                            <div
                                className="iconHover"
                                style={{ display: 'contents' }}
                                onClick={() => props.setviewActividadUsr(false)}
                            >
                                Metricas Actividad Vendedor
                            </div>
                        </h3>
                    </div>
                    <section className="o-layout__item u-1/4">
                        <h4
                            className="u-text-center"
                            style={{ paddingTop: '25px' }}
                        >
                            Filtros
                        </h4>
                        <h3 className="c-accordion__title">
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Operación Financiera
                            </button>
                        </h3>
                        <div className="c-accordion__content c-accordion__content--max-width">
                            <div
                                className="input-div"
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'Opefinanciera',
                                        type: 'text',
                                        placeHolder: 'Introduce una Operación',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Producto Comercial
                            </button>
                        </h3>
                        {false && (
                            <div className="" onChange={onChangeFilter}>
                                <OpComercialFilter
                                    id="OpComercialFilter"
                                    productoComercial={'null'}
                                    setProductoComercial={setProductoComercial}
                                />
                            </div>
                        )}

                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Actividad
                            </button>
                        </h3>
                        <div className="c-input c-input--select">
                            <select
                                id="OperacionActividad"
                                className="c-input__input"
                                onChange={onChangeFilter}
                                defaultValue={''}
                            >
                                {optActividad(props.conceptoslogsMetricas)}
                            </select>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Marca
                            </button>
                        </h3>
                        <div className="c-form-field__box">
                            <div className="c-input c-input--select">
                                {optMarca.length > 0 && (
                                    <select
                                        id="MarcaSelected"
                                        className="c-input__input"
                                        onChange={onChangeFilter}
                                        defaultValue={optMarca[0]}
                                    >
                                        {optMarca}
                                    </select>
                                )}
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Usuario Log
                            </button>
                        </h3>
                        <div className="c-accordion__content c-accordion__content--max-width">
                            <div
                                className="input-div"
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'Usuario',
                                        type: 'text',
                                        placeHolder: 'Introduce un Usuario',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Vendedor original
                            </button>
                        </h3>
                        <div className="c-accordion__content c-accordion__content--max-width">
                            <div
                                className="input-div"
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'Vendedor',
                                        type: 'text',
                                        placeHolder: 'Introduce un Vendedor',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Fecha desde
                            </button>
                        </h3>
                        <div
                            className="c-accordion__content c-accordion__content--max-width"
                            style={{ display: 'flex' }}
                        >
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechDesdeAño',
                                        type: 'number',
                                        placeHolder: 'Año',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechDesdeMes',
                                        type: 'number',
                                        placeHolder: 'Mes',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <h3
                            className="c-accordion__title"
                            style={{ marginTop: '15px' }}
                        >
                            <button className="c-accordion__title-label  js-accordion__title-label">
                                Fecha hasta
                            </button>
                        </h3>
                        <div
                            className="c-accordion__content c-accordion__content--max-width"
                            style={{ display: 'flex' }}
                        >
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechHastaAño',
                                        type: 'number',
                                        placeHolder: 'Año',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                            <div
                                className="input-div"
                                style={{ width: '50%' }}
                                onChange={onChangeFilter}
                            >
                                <Input
                                    options={{
                                        id: 'fechHastaMes',
                                        type: 'number',
                                        placeHolder: 'Mes',
                                        autoComplete: 'off',
                                    }}
                                    onChange={() => {}}
                                />
                            </div>
                        </div>
                        <button
                            className="c-btn o-layout__item u-1/1"
                            style={{ marginTop: '20px' }}
                            onClick={() =>
                                props.tableCreate(
                                    updateData(metricaActividad),
                                    'metricaActividad'
                                )
                            }
                        >
                            descargar metrica Actividad
                        </button>
                    </section>
                    <section className="o-layout__item u-3/4">
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell
                                        style={{
                                            minWidth: '40px',
                                            maxWidth: '40px',
                                        }}
                                    >
                                        Año
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '30px',
                                            maxWidth: '30px',
                                        }}
                                    >
                                        Mes
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '30px',
                                            maxWidth: '30px',
                                        }}
                                    >
                                        Dia
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '100px',
                                            maxWidth: '100px',
                                        }}
                                    >
                                        Operación
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '80px',
                                            maxWidth: '80px',
                                        }}
                                    >
                                        Marca
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '100px',
                                            maxWidth: '100px',
                                        }}
                                    >
                                        Acción
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '100px',
                                            maxWidth: '100px',
                                        }}
                                    >
                                        Concesionario
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '80px',
                                            maxWidth: '80px',
                                        }}
                                    >
                                        Codigo.Conce
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '150px',
                                            maxWidth: '150px',
                                        }}
                                    >
                                        Vendedor Original
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '150px',
                                            maxWidth: '150px',
                                        }}
                                    >
                                        Usuario Log
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '70px',
                                            maxWidth: '70px',
                                        }}
                                    >
                                        Producto
                                    </TableCell>
                                    <TableCell
                                        style={{
                                            minWidth: '90px',
                                            maxWidth: '90px',
                                        }}
                                    >
                                        <div
                                            style={{
                                                minWidth: '100%',
                                                display: 'flex',
                                            }}
                                        >
                                            <div
                                                className="c-icon c-icon--[semantic-user]"
                                                style={{ fontSize: '25px' }}
                                            ></div>
                                            <div
                                                className="c-icon c-icon--[semantic-car] u-hide@s iconLeft-tableVencimiento"
                                                style={{ fontSize: '25px' }}
                                            ></div>
                                            <div
                                                className="c-icon c-icon--[semantic-car] u-hide@s-up  iconLeft-tableVencimiento"
                                                style={{ fontSize: '25px' }}
                                            ></div>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>{rows}</TableBody>
                        </Table>
                        {metricaActividad.length > 10 && (
                            <TablePagination
                                rowsPerPageOptions={[10, 25, 50, 100, 1000]}
                                component="div"
                                count={metricaActividad.length}
                                rowsPerPage={rowsPerPage}
                                page={page}
                                onChangePage={handleChangePage}
                                onChangeRowsPerPage={handleChangeRowsPerPage}
                            />
                        )}
                    </section>
                </section>
            </div>
        </React.Fragment>
    );
};

export default withCookies(withRouter(ActividadUsr));
